import {
  AloftDateJSON,
  PropertyData,
  ZillowPropertySearchResponse,
  schFilledAddress,
  stringToAddress,
} from '@aloft/toolkit-shared';

import { useAutofillProperty } from '../../../hooks/useAutofillProperty.ts';

export const zillowPropToPropertyData =
  (
    autofillProperty: ReturnType<typeof useAutofillProperty>,
    effectiveDate: AloftDateJSON,
    orderID: string,
  ) =>
  (listingData: ZillowPropertySearchResponse): Promise<PropertyData> => {
    const address = schFilledAddress.safeParse(stringToAddress(listingData.address ?? ''));

    if (address.success === false)
      throw new Error(
        `Listing must have valid address details to convert to PropertyData: ${JSON.stringify(
          listingData,
        )}`,
      );

    return autofillProperty({
      address: address.data,
      effectiveDate,
      orderID,
    });
  };
